import { Component, input } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { DurationPipe } from '@tdwb/core';

@Component({
  selector: 'td-wb-learn-duration',
  templateUrl: './learn-duration.component.html',
  styleUrls: ['./learn-duration.component.scss'],
  imports: [
    TranslateDirective,
    DurationPipe
  ]
})
export class LearnDurationComponent {
  readonly duration = input<number>();
  readonly timeRemaining = input<number>();
  readonly isCourse = input(false);

  inProgress(): boolean {
    const timeRemaining = this.timeRemaining();
    return timeRemaining !== undefined && timeRemaining !== 0;
  }
}
